import React,{useState,useEffect,useLayoutEffect} from 'react'
import { useSelector } from 'react-redux'
import {SliderSwitch,CarouselContainer,SlideProductContainer} from '../styles/Home'
import SliderContainer from '../components/Slider'
import SlideProducts from '../components/Slider/Products'
import SlideBrands from '../components/Slider/Brands'

import Header from '../components/Navigation/Header'
import BottomNav from '../components/Navigation/Bottom'
import Footer from '../components/Navigation/Footer'
import "react-activity/dist/Sentry.css";
import ContentLoader from "react-content-loader"

import {useProductRequests} from '../helpers/ProductRequests'
import { useHistory } from 'react-router-dom'

import {Helmet} from "react-helmet";
import CookieConsent, { Cookies } from "react-cookie-consent";
import ProductList from "../components/Content/ProductList";

export default function Home(props) {
  
  const {getProducts,getDiscover,getBrands,getSliders}=useProductRequests()
  
  const {slider}=useSelector(state=>state.site)
  const [sliders,setSliders]=useState('test1')
  const [images,setImages]=useState([])

  const history=useHistory()

  const [discover,setDiscover]=useState([])
  const [man,setMan]=useState([])
  const [women, setWomen] = useState([]);
  const [garson, setGarson] = useState([]);
  const [filet, setFilet] = useState([]);
  const [bebe, setBebe] = useState([]);
  const [patik, setPatik] = useState([]);
  const [products,setProducts]=useState([])
  const [brands, setBrands] = useState([]);
  const [randomProducts,setRandomProducts] = useState([]);
  const [mainPageProducts, setMainPageProducts] = useState([]);

  useLayoutEffect(() => {
    
    if(discover.length===0){

      getProducts({ page: 1, count: 20,productOfDay: true })
        .then((response) => {
          setDiscover(response.data.data.items);

          getProducts({
            page: 1,
            count: 40,
            sort: "TOPSALES",
            productOfMainPage: true,
            sortedBy: "desc",
          })
            .then((response) => {
              setMainPageProducts(response.data.data.items);
              getProducts({
                page: 1,
                count: 50,
                sort: "RANDOM",
                sortedBy: "DESC",
              })
                .then((response) => {
                  setRandomProducts(response.data.data.items);
                })
                .catch((error) => {
                  //history.push('/giris-yap')
                });
            })
            .catch((error) => {
              //history.push('/giris-yap')
            });

          getBrands()
            .then((response) => {
              setBrands(response.data.data);
            })
            .catch((error) => {});
        })
        .catch((error) => {});

      

    }
  }, [])
 

  useEffect(() => {
    //console.log(slider)

    if (images == null || images.length == 0) {
      //REACT_APP_GET_SLIDERS
      localStorage.setItem("slider", "");
      const sliderCheck = localStorage.getItem("sliders");
      if (sliderCheck == null) {
        getSliders().then((res) => {
          setImages(res.data.images);
        });
      }
    }
  }, [sliders]);

  return (
    <>
      <Helmet>
        <title>Ana Sayfa</title>
      </Helmet>
      <CookieConsent
        location="bottom"
        buttonText="Tümünü Kabul Et"
        cookieName="dehasoft"
        style={{
          minHeight: "5vh",
          background: "#FF9F43",
          alignItems: "center",
        }}
        buttonStyle={{ color: "#000", fontSize: "15px" }}
        expires={250}
      >
        Bu web sitesi, kullanıcı deneyimini geliştirmek için tanımlama
        bilgilerini kullanır.{" "}
        <span style={{ fontSize: "10px" }}> &copy; dehasoft 2023</span>
      </CookieConsent>
      <Header />

      <div>
        {images != null && images.length > 0 ? (
          <CarouselContainer colors={slider}>
            <SliderSwitch>
              {/* <button onClick={()=>setSliders('test1')} className={sliders=='test1' ? 'active' : ''}>Afişlerimiz</button> */}
              {/* <button onClick={()=>setSliders('test2')} className={sliders=='test2' ? 'active' : ''}>Hepsi</button>  */}
              {/* <button onClick={()=>setSliders('test3')} className={sliders=='test3' ? 'active' : ''}>Hepsi</button>  */}
            </SliderSwitch>

            <SliderContainer images={images} products={discover} />
          </CarouselContainer>
        ) : (
          <></>
        )}

        

        <SlideProductContainer width={"90%"} left={"5%"}>
          {mainPageProducts != null &&
          mainPageProducts != undefined &&
          mainPageProducts.length > 0 ? (
            <>
              <SlideProducts
                items={mainPageProducts.slice(0, 10)}
                items2={mainPageProducts.slice(10, 20)}
              />
            </>
          ) : (
            <div className="loader">
              {/* <ContentLoader speed={0.5} width={221} height={300} style={{marginRight: '20px'}} backgroundColor="#f3f3f3" foregroundColor="#ecebeb" {...props} ><rect x="0" y="0" rx="0" ry="0" width="221" height="250" /><rect x="0" y="260" rx="3" ry="3" width="221" height="10" /><rect x="0" y="275" rx="3" ry="3" width="221" height="10" /><rect x="0" y="290" rx="3" ry="3" width="221" height="10" /></ContentLoader>
              <ContentLoader speed={0.5} width={221} height={300} style={{marginRight: '40px'}} backgroundColor="#f3f3f3" foregroundColor="#ecebeb"  {...props} ><rect x="0" y="0" rx="0" ry="0" width="221" height="250" /><rect x="0" y="260" rx="3" ry="3" width="221" height="10" /><rect x="0" y="275" rx="3" ry="3" width="221" height="10" /><rect x="0" y="290" rx="3" ry="3" width="221" height="10" /> </ContentLoader>
              <ContentLoader speed={0.5} width={221} height={300} style={{marginRight: '40px'}} backgroundColor="#f3f3f3" foregroundColor="#ecebeb"  {...props} ><rect x="0" y="0" rx="0" ry="0" width="221" height="250" /><rect x="0" y="260" rx="3" ry="3" width="221" height="10" /><rect x="0" y="275" rx="3" ry="3" width="221" height="10" /><rect x="0" y="290" rx="3" ry="3" width="221" height="10" /> </ContentLoader>
              <ContentLoader speed={0.5} width={221} height={300} style={{marginRight: '40px'}} backgroundColor="#f3f3f3" foregroundColor="#ecebeb"  {...props} ><rect x="0" y="0" rx="0" ry="0" width="221" height="250" /><rect x="0" y="260" rx="3" ry="3" width="221" height="10" /><rect x="0" y="275" rx="3" ry="3" width="221" height="10" /><rect x="0" y="290" rx="3" ry="3" width="221" height="10" /> </ContentLoader>
              <ContentLoader speed={0.5} width={221} height={300} style={{marginRight: '40px'}} backgroundColor="#f3f3f3" foregroundColor="#ecebeb"  {...props} ><rect x="0" y="0" rx="0" ry="0" width="221" height="250" /><rect x="0" y="260" rx="3" ry="3" width="221" height="10" /><rect x="0" y="275" rx="3" ry="3" width="221" height="10" /><rect x="0" y="290" rx="3" ry="3" width="221" height="10" /> </ContentLoader> */}
            </div>
          )}
        </SlideProductContainer>

        <SlideProductContainer width={"90%"} left={"5%"}>
          {mainPageProducts != null &&
          mainPageProducts != undefined &&
          mainPageProducts.length > 20 &&
          mainPageProducts.length > 0 ? (
            <>
              <SlideProducts
                items={mainPageProducts.slice(20, 30)}
                items2={mainPageProducts.slice(30, 40)}
              />
            </>
          ) : (
            <div className="loader">
              {/* <ContentLoader speed={0.5} width={221} height={300} style={{marginRight: '20px'}} backgroundColor="#f3f3f3" foregroundColor="#ecebeb" {...props} ><rect x="0" y="0" rx="0" ry="0" width="221" height="250" /><rect x="0" y="260" rx="3" ry="3" width="221" height="10" /><rect x="0" y="275" rx="3" ry="3" width="221" height="10" /><rect x="0" y="290" rx="3" ry="3" width="221" height="10" /></ContentLoader>
              <ContentLoader speed={0.5} width={221} height={300} style={{marginRight: '40px'}} backgroundColor="#f3f3f3" foregroundColor="#ecebeb"  {...props} ><rect x="0" y="0" rx="0" ry="0" width="221" height="250" /><rect x="0" y="260" rx="3" ry="3" width="221" height="10" /><rect x="0" y="275" rx="3" ry="3" width="221" height="10" /><rect x="0" y="290" rx="3" ry="3" width="221" height="10" /> </ContentLoader>
              <ContentLoader speed={0.5} width={221} height={300} style={{marginRight: '40px'}} backgroundColor="#f3f3f3" foregroundColor="#ecebeb"  {...props} ><rect x="0" y="0" rx="0" ry="0" width="221" height="250" /><rect x="0" y="260" rx="3" ry="3" width="221" height="10" /><rect x="0" y="275" rx="3" ry="3" width="221" height="10" /><rect x="0" y="290" rx="3" ry="3" width="221" height="10" /> </ContentLoader>
              <ContentLoader speed={0.5} width={221} height={300} style={{marginRight: '40px'}} backgroundColor="#f3f3f3" foregroundColor="#ecebeb"  {...props} ><rect x="0" y="0" rx="0" ry="0" width="221" height="250" /><rect x="0" y="260" rx="3" ry="3" width="221" height="10" /><rect x="0" y="275" rx="3" ry="3" width="221" height="10" /><rect x="0" y="290" rx="3" ry="3" width="221" height="10" /> </ContentLoader>
              <ContentLoader speed={0.5} width={221} height={300} style={{marginRight: '40px'}} backgroundColor="#f3f3f3" foregroundColor="#ecebeb"  {...props} ><rect x="0" y="0" rx="0" ry="0" width="221" height="250" /><rect x="0" y="260" rx="3" ry="3" width="221" height="10" /><rect x="0" y="275" rx="3" ry="3" width="221" height="10" /><rect x="0" y="290" rx="3" ry="3" width="221" height="10" /> </ContentLoader> */}
            </div>
          )}
        </SlideProductContainer>

       
      </div>

      <BottomNav />

      <Footer />
    </>
  );
}
